/* eslint-disable react/no-unescaped-entities */
import { memo } from 'react'
import { Link } from '@mui/material'
import { useClientDetails } from 'stores/utils/hooks/useClientDetails'
import useEmotionStyles from 'hooks/useEmotionStyles'
import { getFooterSeals } from 'components/Footer/getSeals'
import Seals from 'components/Footer/Seals'
import CategoryLayout from 'components/Layout/Category'

const styles = () => ({
  paragraph: {
    color: 'rgb(45, 55, 72)',
    lineHeight: '1.25rem',
    fontSize: '.8125rem'
  }
})

const Agb = () => {
  const clientDetails = useClientDetails()

  const { paragraph } = useEmotionStyles(styles)

  return (
    <CategoryLayout>
      <Seals seals={getFooterSeals()} itemMargin={16} />
      <>
        <p className={paragraph}>
          Mit Klicken des "Direkt zu den Angeboten"-Buttons erteile ich
          FINANZCHECK einen kostenlosen Kreditvergleichs- und
          Vermittlungsauftrag und akzeptiere die{' '}
          <Link
            href={clientDetails?.urls?.termsAndConditions}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700 }}
          >
            AGB
          </Link>
          . Die{' '}
          <Link
            href={clientDetails?.urls?.precontractual}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700 }}
          >
            Pflichtinformationen
          </Link>{' '}
          und die{' '}
          <Link
            href={clientDetails?.urls?.dataProtection}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 700 }}
          >
            Datenschutzhinweise
          </Link>{' '}
          habe ich erhalten.
        </p>
      </>
    </CategoryLayout>
  )
}
export default memo(Agb)
